import { tagProperties } from "./actor.js";
/**
 * An object which matched IDs and and actor classes, is used for loading level actors
 */
export const actorDB = {};
export const tagFlags = new Map();
export function makeTagFlagField(tags) {
    if (typeof tags === "bigint")
        return tags;
    return tags.reduce((acc, tag) => {
        if (tagFlags.has(tag))
            return acc | tagFlags.get(tag);
        const flag = BigInt(1) << BigInt(tagFlags.size);
        tagFlags.set(tag, flag);
        return acc | flag;
    }, BigInt(0));
}
export function registerTaggedType(actorType) {
    var _a;
    for (const prop of tagProperties.concat((_a = actorType.extraTagProperties) !== null && _a !== void 0 ? _a : [])) {
        if (!actorType[prop])
            continue;
        actorType[prop] = makeTagFlagField(actorType[prop]);
    }
    if (actorType.carrierTags) {
        for (const prop in actorType.carrierTags) {
            actorType.carrierTags[prop] = makeTagFlagField(actorType.carrierTags[prop]);
        }
    }
}
export function getTagFlag(tag) {
    var _a;
    return (_a = tagFlags.get(tag)) !== null && _a !== void 0 ? _a : BigInt(0);
}
export function hasTag(actor, tag) {
    return !!(actor.tags & getTagFlag(tag));
}
export function hasTagOverlap(tags1, tags2) {
    return !!(tags1 & tags2);
}
/**
 * The position of keys to show in the inventory preview
 */
export const keyNameList = [];
export const cc1BootNameList = [];
/**
 * A decision an actor can take
 */
export var Decision;
(function (Decision) {
    Decision[Decision["NONE"] = 0] = "NONE";
    Decision[Decision["UP"] = 1] = "UP";
    Decision[Decision["RIGHT"] = 2] = "RIGHT";
    Decision[Decision["DOWN"] = 3] = "DOWN";
    Decision[Decision["LEFT"] = 4] = "LEFT";
})(Decision || (Decision = {}));
//# sourceMappingURL=const.js.map